import { FC, useEffect } from "react";
import { Link } from "react-router-dom";
import { MemberCarpet } from "../../../typings/member";
import usePrepareLink from "../../../hooks/usePrepareLink";
import { GET_PARAMS, GET_POPUPS } from "../../../const/router";
import { GenderType, HomeCarpetFilterCategory } from "../../../helpers/Enums";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";

export type ProfileItemProps = {
  member: MemberCarpet;
};

const ProfileItem: FC<ProfileItemProps> = ({ member }) => {
  const { homeFilterCategory } = useSelector(
    (state: RootState) => state.carpet
  );

  const tagsNumClass = (tagsCount: number | null) => {
    if (tagsCount !== null) {
      if (tagsCount >= 0 && tagsCount <= 3) {
        return "tag_num";
      } else if (tagsCount >= 4 && tagsCount <= 6) {
        return "tag_num _2";
      }
      return "tag_num _3";
    } else {
      return "tag_num";
    }
  };
  // home filter category
  const isHFCSimilarTags = () => {
    if (
      homeFilterCategory.value ===
      HomeCarpetFilterCategory.ORDER_BY_SIMILAR_TAGS
    ) {
      return true;
    } else {
      return false;
    }
  };

  const link = usePrepareLink({
    state: {
      navigateFromProfile: true,
    },
    query: {
      [GET_PARAMS.memberCode]: member.memberCode,
    },
    pushToQuery: {
      [GET_PARAMS.popup]: GET_POPUPS.popup.profile,
    },
    keepOldQuery: true,
  });

  const homeFilterCategoryTagsComponent = () => {
    if (member.sharedTagsCount! > 0 && isHFCSimilarTags()) {
      return (
        <>
          <div className="tag_num_group">
            <div className={tagsNumClass(member.sharedTagsCount)}>
              <div>{member.sharedTagsCount}</div>
            </div>
            נושאים משותפים
          </div>
          <div className="prof_tag_list w-list-unstyled">
            {member.sharedTagsNames?.split(",").map((x) => (
              <div className="prof_tag">{x}</div>
            ))}
            {member.sharedTagsCount! > 6 && (
              <div className="prof_tag add">עוד...</div>
            )}
          </div>
        </>
      );
    }
  };

  useEffect(() => {
    console.log("ProfileItem link: ", link);
  }, [link]);

  return (
    <>
      <li className="gallery_list_item prof">
        <div className="item_pict_block">
          {member?.profileImageUrl && (
            <img
              //src={"/assets/images/noPhoto.png"}
              src={member?.profileImageUrl}
              loading="lazy"
              alt=""
              className="item_pict"
            />
          )}
        </div>
        <Link to={link} className="gallery_link prof w-inline-block">
          {(member.isSendStickerToMember ||
            member.isMatched ||
            member.sentByMe === 1) && (
            <div className="item_status_group">
              <div className="status_icon ">
                <img
                  src={
                    member.isMatched
                      ? "/assets/images/ic_shosh_red.svg"
                      : member.sentByMe === 1
                      ? "/assets/images/ic_bou_violet.svg"
                      : ""
                  }
                  loading="lazy"
                  alt=""
                />
              </div>
              <div className="status_icon gift">
                <img
                  src={
                    member.isSendStickerToMember
                      ? "/assets/images/ic_gift_sm.svg"
                      : ""
                  }
                  loading="lazy"
                  alt=""
                />
              </div>
            </div>
          )}

          <div className="gallery_prof_info">
            <div className="user_basic_info">
              <h2 className="user_name" dir="rtl">
                {member.userName},
              </h2>
              {/* <span> </span> */}
              <span className="age_txt">{member.age}</span>
              {/* <div>סוג התאמה: {member.isMatched ? "ההתאמות שלי" : member.sentByMe === 1 ? 'שלח לי בוא נכיר' : 'אין'}</div> */}
              {member.profileIsVerified &&
              member.hasBeenAuthenticatedByPhone ? (
                <div className="ic_vi" />
              ) : null}
            </div>
            <span>
              {member.personalStatus ? `${member.personalStatus}` : ""}
              {member.city ? `, ${member.city}` : ""}
              {member.isOnline
                ? member.genderId === GenderType.MALE
                  ? ", מחובר עכשיו"
                  : ", מחוברת עכשיו"
                : ""}
            </span>
          </div>

          <div className="gallery_prof_info status">
            {homeFilterCategoryTagsComponent()}

            {member.moodName && !isHFCSimilarTags() && (
              <div className="flah">אשמח ל{member.moodName}</div>
            )}
            {member.aboutMeDescription && (
              <h2 className="user_name info">
                {member.aboutMeDescription.length > 80
                  ? `${member.aboutMeDescription?.slice(0, 80)}...`
                  : member.aboutMeDescription}
              </h2>
            )}
            {/* {
                            member.profileStatementUpdate === "never"
                                ? null
                                : <div>{member.profileStatementUpdate}</div>
                        } */}
            {/* <Link to={link} className="button profile">
                            <div>לפרופיל המלא</div>
                        </Link> */}
            <div className="button profile">
              <div>לפרופיל המלא</div>
            </div>
          </div>
        </Link>
      </li>
    </>
  );
};

export default ProfileItem;
